/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { EcdsaSecp256K1VerificationKey2019 } from './EcdsaSecp256K1VerificationKey2019';
import { VerificationMethodMultikey } from './VerificationMethodMultikey';

export const DidDocumentVerificationMethodItem: core.serialization.Schema<
    serializers.DidDocumentVerificationMethodItem.Raw,
    Truvity.DidDocumentVerificationMethodItem
> = core.serialization.undiscriminatedUnion([EcdsaSecp256K1VerificationKey2019, VerificationMethodMultikey]);

export declare namespace DidDocumentVerificationMethodItem {
    export type Raw = EcdsaSecp256K1VerificationKey2019.Raw | VerificationMethodMultikey.Raw;
}
